import React, { useEffect } from 'react';
import { calculateProductPrice } from '../../utils';
import store from '../../redux/store';
import { UPDATE_LOYALTY } from '../../redux/actions/types';
import Cart from './components/Cart';
import OrderDetail from './components/OrderDetail';
import { useAppSelector } from '../../redux/hook';
import { getCompanyLoyalty } from '../../api/company';

export default function Order({
  showCart = false,
  order,
  showPromo = false,
  deleteOption = false,
  showFees = false,
  fetchLoyalty = false,
}) {
  const totalProductPrice = calculateProductPrice();
  const { companyId } = useAppSelector((state) => state.configurationReducer);

  useEffect(() => {
    const handleFetchLoyalty = async () => {
      const loyalty = await getCompanyLoyalty(companyId);
      store.dispatch({ type: UPDATE_LOYALTY, payload: loyalty });
    };

    if (fetchLoyalty) handleFetchLoyalty();
  }, [fetchLoyalty]);

  return showCart ? (
    <Cart
      order={order}
      showPromo={showPromo}
      deleteOption={deleteOption}
      totalProductPrice={totalProductPrice}
    />
  ) : (
    <OrderDetail
      order={order}
      showFees={showFees}
      deleteOption={deleteOption}
      totalProductPrice={totalProductPrice}
    />
  );
}
